import layout from './ReducedWireframeView.html?raw';
import ComponentManager from '@/Management/ComponentManager';
import WireframeViewModel from '@/ViewModels/Views/WireframeViewModel';
import WireframeView from '@/Views/WireframeView';

export default class ReducedWireframeView extends WireframeView {

    constructor(viewModel: WireframeViewModel, protected element?: JQuery) {
        super(viewModel, element);

        this.view = this.applyBindings(this.element, this.viewModel, layout);
    }
}

ComponentManager.setView('ReducedWireframe', ReducedWireframeView, 'RADPresentation.HTMLClient.DefaultViewExtensions');